import { Link } from 'react-router-dom'
import { cn } from '@/lib/utils/helpers'
import { primaryEntityActionButtonClass, secondaryEntityActionButtonClass } from '@/components/ui/entityActionButtonClasses'
import type { OrganizationEditSectionProps } from '../../types/components'

export function OrganizationEditActionBar({ ctx }: OrganizationEditSectionProps) {
  return (
    <div className="mt-4 flex flex-wrap items-center justify-center gap-2 border-t border-slate-200 bg-[#f8fafc] pt-4 pb-4">
      <button
        type="submit"
        disabled={ctx.submitting || !ctx.isValid || (!ctx.isEdit && !ctx.logoFiles.org_logo)}
        className={cn(primaryEntityActionButtonClass, "px-5 py-2 text-sm font-medium disabled:opacity-50")}
      >
        {ctx.submitting ? 'Saving...' : ctx.isEdit ? 'Save Changes' : 'Create Organization'}
      </button>
      <Link
        to="/organizations"
        className={cn(secondaryEntityActionButtonClass, "px-5 py-2 text-sm font-medium")}
      >
        Cancel
      </Link>
    </div>
  )
}
